<template>
    <div data-component="Tooltip"
         class="tooltip"
         :class="getArrowPosition"
         :style="styleObject">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        styleObject: {
            type: Object,
            default: () => {},
        },
        arrowPosition: {
            type: String,
            default: 'top-centre',
        },
    },

    computed: {
        getArrowPosition() {
            return 'arrow-' + this.arrowPosition;
        },
    },
};

</script>

<style lang="less">
@import "../../less/variables";
@import (less, reference) "../../less/vendor/fontawesome.less";

.tooltip {
    position: absolute;
    background: white;
    border: 1px solid @btn-default-border;
    filter: drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.2)); // Use filter rather than box-shadow so it includes the arrow.
    border-radius: @border-radius-base; // This is 8px in the designs but it looks weird in reality.
    width: 220px;
}

// We have 6 x arrow positions.
// top-left
// top-centre (default)
// top-right
// bottom-left
// bottom-center
// bottom-right

// Arrow pointing up (default) - appears on the centre of the top edge.
.tooltip.arrow-top-centre::before,
.tooltip.arrow-top-centre::after {
    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-style: solid;
}

.tooltip.arrow-top-centre::before {
    bottom: 100%;
    border-width: 0 10px 10px 10px;
    border-color: transparent transparent @default-grey transparent;
}

.tooltip.arrow-top-centre::after {
    bottom: 100%;
    border-width: 0 9px 9px 9px;
    border-color: transparent transparent white transparent;
    margin-bottom: -1px;
}

// Arrow pointing down - appears on the centre of the bottom edge.
.tooltip.arrow-bottom-centre::before,
.tooltip.arrow-bottom-centre::after {
    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-style: solid;
}

.tooltip.arrow-bottom-centre::before {
    top: 100%;
    border-width: 10px 10px 0 10px;
    border-color: @default-grey transparent transparent transparent;
}

.tooltip.arrow-bottom-centre::after {
    top: 100%;
    border-width: 9px 9px 0 9px;
    border-color: white transparent transparent transparent;
    margin-top: -1px;
}

// Arrow pointing up - appears on the left side of the top edge.
.tooltip.arrow-top-left::before,
.tooltip.arrow-top-left::after {
    content: '';
    position: absolute;
    left: 0;
    width: 0;
    height: 0;
    border-style: solid;
}

.tooltip.arrow-top-left::before {
    bottom: 100%;
    border-width: 0 10px 10px 10px;
    border-color: transparent transparent @default-grey transparent;
}

.tooltip.arrow-top-left::after {
    bottom: 100%;
    border-width: 0 9px 9px 9px;
    border-color: transparent transparent white transparent;
    margin-bottom: -1px;
}

// Arrow pointing up - appears on the right side of the top edge.
.tooltip.arrow-top-right::before,
.tooltip.arrow-top-right::after {
    content: '';
    position: absolute;
    right: 0;
    width: 0;
    height: 0;
    border-style: solid;
}

.tooltip.arrow-top-right::before {
    bottom: 100%;
    border-width: 0 10px 10px 10px;
    border-color: transparent transparent @default-grey transparent;
}

.tooltip.arrow-top-right::after {
    bottom: 100%;
    border-width: 0 9px 9px 9px;
    border-color: transparent transparent white transparent;
    margin-bottom: -1px;
}

// Arrow pointing down - appears on the left side of the bottom edge.
.tooltip.arrow-bottom-left::before,
.tooltip.arrow-bottom-left::after {
    content: '';
    position: absolute;
    left: 0;
    width: 0;
    height: 0;
    border-style: solid;
}

.tooltip.arrow-bottom-left::before {
    top: 100%;
    border-width: 10px 10px 0 10px;
    border-color: @default-grey transparent transparent transparent;
}

.tooltip.arrow-bottom-left::after {
    top: 100%;
    border-width: 9px 9px 0 9px;
    border-color: white transparent transparent transparent;
    margin-top: -1px;
}

// Arrow pointing down - appears on the right side of the bottom edge.
.tooltip.arrow-bottom-right::before,
.tooltip.arrow-bottom-right::after {
    content: '';
    position: absolute;
    right: 0;
    width: 0;
    height: 0;
    border-style: solid;
}

.tooltip.arrow-bottom-right::before {
    top: 100%;
    border-width: 10px 10px 0 10px;
    border-color: @default-grey transparent transparent transparent;
}

.tooltip.arrow-bottom-right::after {
    top: 100%;
    border-width: 9px 9px 0 9px;
    border-color: white transparent transparent transparent;
    margin-top: -1px;
}

</style>
